import React from 'react';
import { StyleSheet } from 'react-native';
import { YStack } from '@tamagui/stacks';
import { Text } from '@tamagui/core';
import { COLORS } from '@/constants/colors';

type MessageBubbleProps = {
  message: string;
  time: string;
  isOwn: boolean;
  isDark?: boolean;
  type?: 'text' | 'gift' | 'system';
  giftData?: {
    giftId: string;
    giftName: string;
    giftEmoji: string;
    amount: number;
  };
};

const MessageBubble = React.memo<MessageBubbleProps>(({ message, time, isOwn, isDark, type = 'text', giftData }) => {
  const bubbleBg = isOwn ? '#8A9BA7' : '#9C919F';
  const giftBg = COLORS.PINK;
  const textColor = COLORS.BLACK;
  const timeColor = 'rgba(0, 0, 0, 0.6)';

  // System messages (e.g., "User joined the chat")
  if (type === 'system') {
    return (
      <YStack alignSelf="center" paddingVertical="$2">
        <Text fontSize={12} color={isDark ? COLORS.GRAY_400 : COLORS.GRAY_500} textAlign="center">
          {message}
        </Text>
      </YStack>
    );
  }

  // Gift messages
  if (type === 'gift' && giftData) {
    return (
      <YStack
        alignSelf={isOwn ? 'flex-end' : 'flex-start'}
        maxWidth="75%"
        paddingHorizontal="$4"
        paddingVertical="$3"
        borderRadius={18}
        backgroundColor={giftBg}
        style={[
          styles.bubble,
          isOwn ? styles.ownBubble : styles.otherBubble,
        ]}
      >
        <Text fontSize={32} textAlign="center">
          {giftData.giftEmoji}
        </Text>
        <Text fontSize={14} color={COLORS.WHITE} fontWeight="600" textAlign="center" marginTop="$1">
          {giftData.giftName}
        </Text>
        <Text fontSize={12} color="rgba(255,255,255,0.8)" textAlign="center">
          {giftData.amount} zł
        </Text>
        <Text fontSize={11} color="rgba(255,255,255,0.6)" alignSelf="flex-end" marginTop="$1">
          {time}
        </Text>
      </YStack>
    );
  }

  // Regular text messages
  return (
    <YStack
      alignSelf={isOwn ? 'flex-end' : 'flex-start'}
      maxWidth="75%"
      paddingHorizontal="$3"
      paddingVertical="$2"
      borderRadius={18}
      backgroundColor={bubbleBg}
      style={[
        styles.bubble,
        isOwn ? styles.ownBubble : styles.otherBubble,
      ]}
    >
      <Text fontSize={15} color={textColor} lineHeight={20}>
        {message}
      </Text>
      <Text fontSize={11} color={timeColor} alignSelf="flex-end" marginTop="$1">
        {time}
      </Text>
    </YStack>
  );
});

const styles = StyleSheet.create({
  bubble: {
    marginTop: 6,
    marginBottom: 6,
    marginHorizontal: 4,
  },
  ownBubble: {
    borderBottomRightRadius: 4,
  },
  otherBubble: {
    borderBottomLeftRadius: 4,
  },
});

MessageBubble.displayName = 'MessageBubble';

export default MessageBubble;


